import { render, staticRenderFns } from "./TechnicianPaymentItemsNewModal.vue?vue&type=template&id=018747b2&"
import script from "./TechnicianPaymentItemsNewModal.vue?vue&type=script&lang=js&"
export * from "./TechnicianPaymentItemsNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports